<!-- PASSPHRASE MODAL -->
<div class="modal fade" id="passphraseModal"  aria-labelledby="passphraseModal" aria-hidden="true" [ngStyle]="{'display': this.universalService.showPassPhraseReset ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content mob-white-modal-bg">
      <!-- Modal Header -->
      <div class="modal-header border-0">
        @if (!this.universalService.forgotPassPhraseModalOpned) {
          <h2>
            <span class="NeueBack d-md-none mr-0"></span>Set new passphrase
          </h2>
          <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="close()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
        @if (this.universalService.forgotPassPhraseModalOpned) {
          <div class="login-close-btn-cont" (click)="close()">
            <span class="NeueFile_Cancel"></span>
          </div>
          <h2>
            <span class="NeueBack d-md-none mr-0" (click)="close()"></span>Forgot Passphrase
          </h2>
        }
      </div>
      <!-- Modal body -->
      <div class="modal-body no-flex border-0">
        <div class="set-passphrase-input mt-0 ml-0 mr-0 pr-0">
          <!-- Note -->
          <div class="pass-note" >
            @if (!this.universalService.forgotPassPhraseModalOpned) {
              <p><strong>NOTE:</strong> Passphrase will be enabled on all your devices.</p>
            }
          </div>
          <p>
            <input #passPhrase type="password" class="" id="newPassPhrase" autofocus placeholder="Enter new passphrase" (keydown.enter)="sendOTP(passPhrase.value,confirmPassPhrase.value)"
              maxlength="20" (keyup)="onKeyupEvent($event,passPhrase.value,confirmPassPhrase.value)" onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off/>
            <button (click)="showHideRestPaasword('newPassPhrase','newPassPhraseBtn')" class="eyeBtn" [disabled]="passPhrase.value == ''" id="newPassPhraseBtn">
              <i class="NeuePassword-Show" aria-hidden="true"  ></i>
              <i class="NeuePassword-Hide hide" aria-hidden="true"></i>
            </button>
          </p>

          <p>
            <input tabindex="0" #confirmPassPhrase type="password" id="confirmPassPhrase" class="" autofocus placeholder="Re-enter new passphrase" (keydown.enter)="sendOTP(passPhrase.value,confirmPassPhrase.value)"
              maxlength="20" (keyup)="onKeyupEvent($event,passPhrase.value,confirmPassPhrase.value)"   onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off/>
            <button (click)="showHideRestPaasword('confirmPassPhrase','confirmPassPhraseBtn')" class="eyeBtn" [disabled]="confirmPassPhrase.value == ''" id="confirmPassPhraseBtn">
              <i class="NeuePassword-Show" aria-hidden="true"></i>
              <i class="NeuePassword-Hide hide" aria-hidden="true"></i>
            </button>
          </p>

          <!-- Error Msg -->
          @if (this.showError) {
            <div class="err-message">
              <p><span class="NeueAlert mr-1 pr-0"></span>{{this.showErrorMess}}</p>
            </div>
          }
          <!-- Note -->
          <p class="note">Passphrase length should be between 6 to 20 characters.<br> Passphrase should not contain any spaces. <br>Passphrase should be Alphanumeric (A-Z, a-z, 0-9).
          </p>
        </div>

      </div>

      <!-- Modal footer -->
      <div class="modal-footer border-0">

        <div class="btn-wrap">
          <p class="otp-note">OTP will be sent to your registered mobile number / email address.</p>
          <button class="btn btn-submit m-gradiant-btn" [disabled]="!this.getOtpButton" (click)="sendOTP(passPhrase.value,confirmPassPhrase.value)">Get OTP</button>
          <!-- Back Icon -->
          <!-- <div class="icon-back mt-4 d-none d-md-block">
          <span class="NeueBack" title="Go back"></span>
        </div> -->
      </div>
    </div>

  </div>
</div>
</div>